import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { WIRE_DETAILS } from './WireInstructions.meta';
import { AsyncComponentHookResult } from '../../../../Types/ComponentHookResult';
import { useApexAccountStatusSummaryQuery } from '../../api/useApexAccountStatusSummaryQuery';
import { currentClientSelector } from '../../../../CommonSelectors/CommonAreaSelector';

interface WireInstruction {
  label: string;
  value: string;
}

export const useWireInstructions = (): AsyncComponentHookResult<WireInstruction[]> => {
  const queryResult = useApexAccountStatusSummaryQuery();

  const { FirstName: firstName, LastName: lastName } = useSelector(currentClientSelector);

  const data = useMemo(() => {
    if (!queryResult.data) {
      return null;
    }

    const comment = {
      label: 'Comment',
      value: `FFC ${firstName} ${lastName} #${queryResult.data.ApexAccountNumber}`,
    };

    return [...WIRE_DETAILS, comment];
  }, [queryResult, firstName, lastName]);

  return {
    ...queryResult,
    data,
  };
};
